import { stopEvent } from '../../utils/event-utils';

export const ngContextmenuDirectiveModule = angular
  .module('Q.components.ng-contextmenu', [])

  /**
   * @ngdoc directive
   * @name ngContextmenu
   *
   * @description
   * The ngContextmenu directive allows you to specify custom behavior when the user tries to open the context menu.
   *
   * @element ANY
   * @priority 0
   * @param {expression} ngContextmenu {@link guide/expression Expression} to evaluate upon
   * click. ({@link guide/expression#-event- Event object is available as `$event`})
   */
  .directive('ngContextmenu', function ($parse) {
    return function (scope, element, attrs) {
      element.bind('contextmenu', function (event) {
        scope.$apply(function () {
          stopEvent(event);
          $parse(attrs.ngContextmenu)(scope, { $event: event });
        });
      });
    };
  });
